export const API_CARD_ROOT_ENDPOINT = "/Card"

export const POLL_INTERVAL = 1000
